import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import "../../assets/scss/custom/pages/_signup.scss";
import Select from "react-select";
import logo from "../../assets/images/cashinvoice_logo.png"
import {
  Row,
  Col,
  Form,
  Input,
  FormFeedback,
  Label,
  Button,

} from "reactstrap"
//redux
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { BsInfoCircle } from "react-icons/bs";
// React hook form validation
import * as Yup from "yup"

// actions
// import { loginUser, clearError } from "../../store/actions"

import { useFormik } from "formik";

import { addSignupInquiry } from "../../helpers/UAM/signInquiry.helper";

import { addNonRegisterDealer } from "../../helpers/UAM/inquiry.helper"

import ToastDialog from "components/Common/ToastDialog";
import { getStateListForInquiry } from "helpers/UAM/signInquiry.helper";
import { SystemConfigurationContext } from "context/systemConfigContext";
import { Tooltip } from 'react-tooltip';

const schema = Yup
  .object({
    email: Yup
      .string()
      .required("Please enter your email")
      .email("Please enter valid email"),
    password: Yup.string().required("Please enter your password"),
  })
  .required()

const Register = props => {
  //meta title
  document.title = "DMS | Inquiry"
  const {inputMax} = useContext(SystemConfigurationContext)

  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [toastInfo, setToastInfo] = useState({ showToast: false });

  const [activeTab, setActiveTab] = useState("dealerInquiry")

  const [showDealerInquiry, setShowDealerInquiry] = useState(true);
  const [showProductInquiry, setShowProductInquiry] = useState(false);

  const [stateList, setStateList] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedProductState, setSelectedProductState] = useState(null);
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
      phone: "",
      name: "",
      companyName: "",
      inquiry: "",
      address: "",
      state: "",
    },

    validationSchema: Yup.object({
      email: Yup.string()
        .email("Must be a valid Email")
        .max(255)
        .required("Email is required"),
      phone: Yup.string()
      .typeError("Phone Number must be a number")
        .required("Please Enter Mobile Number")
        .matches(/^[0-9]+$/, { 
          message: "Phone Number must be a number", 
          excludeEmptyString: true 
        })
        .matches(/^\d{10}$/, "Phone Number must be exactly 10 digits"),
      name: Yup.string().required("Please Enter Your Name"),
      companyName: Yup.string().required("Please Enter Comapany name"),
      inquiry: Yup.string().required("Please Enter Inquiry"),
      address: Yup.string().required("Please Enter Address"),
      state: Yup.string().required("Please Enter State"),
    }),

    onSubmit: (values) => {
      AddSignUpData(values);
    }
  });

  const validationProductInquiry = useFormik({
    enableReinitialize: true,

    initialValues: {
      //Product Inquiry
      fullName: "",
      mobile: "",
      email: "",
      companyName: "",
      address: "",
      state: "",
      pincode: "",
      productDescription: "",
      quantity: "",
      deliveryDate: "",
      price: "",
    },

    validationSchema: Yup.object({
      //Product Inquiry
      fullName: Yup.string().required("Please Enter Your Name"),
      mobile: Yup.string()
        .typeError("Phone Number must be a number")
        .required("Please Enter Phone Number")
        .matches(/^[0-9]+$/, { 
          message: "Phone Number must be a number", 
        })
        .matches(/^\d{10}$/, "Phone Number must be exactly 10 digits"),
      address: Yup.string().required("Please Enter Address"),
      companyName: Yup.string().required("Please Enter Company Name"),
      email: Yup.string()
        .email("Must be a valid Email")
        .max(255)
        .required("Please Enter Your Email"),
      state: Yup.string().required("Please Enter State"),
      pincode: Yup.string()
        .required("Please Enter Pincode")
        .typeError("Pincode must be a number")
        .matches(/^\d{6}$/, "Pincode must be exactly 6 digits")
        .test('is-positive', 'Pincode must not be negative', val => parseInt(val, 10) >= 0)
        .min(6, "Pincode must be 6 digits")
        .max(6, "Pincode must be 6 digit"),
      productDescription: Yup.string().required("Please Description the Product"),
     
      quantity: Yup.number()
        .required("Please Enter Quantity")
        .typeError("Quantity must be a number")
        .positive("Quantity must be a positive number")
        .min(1, "Quantity value must be greater than 0")
        .max(100, "Quantity value must be less than or equal to 100"),

      deliveryDate: Yup.string().required("Please Enter Expected Delivery Date"),
      price: Yup.number()
        .required("Please Enter Expected Price")
        .typeError("Price must be a number")
        .min(1, "Price value must be greater than 0")
    }),

    onSubmit: (values) => {
      AddProductInquiry(values)
    }
  })



  const dialogAction = (action, data) => {
    if (action == 1) {
      // setShowCommonDialog({ isShow: false })
      AddSignUpData();
      AddProductInquiry();
    } else {
      setShowCommonDialog({ isShow: false })
    }
  }

  const AddSignUpData = (values) => {
    const newSignupInquiry = {
      email: values.email,
      phone: values.phone,
      personName: values.name,
      companyName: values.companyName,
      inquiry: values.inquiry,
      address: values.address,
      state: values.state,
    }
    addSignupInquiry(newSignupInquiry)
      .then(responseFromApi => {
        if (responseFromApi.status && responseFromApi.code == 201) {
          validation.setSubmitting(false);
          validation.resetForm();
          setSelectedState(null)
          setToastInfo({
            message: responseFromApi.message,
            showToast: true,
            role: "success",
          });
        }
      })
      .catch((err) => { console.log(err); })
  }


  const AddProductInquiry = (values) => {
    const newProductInquiry = {
      fullName: values.fullName,
      mobile: values.mobile,
      email: values.email,
      companyName: values.companyName,
      address: values.address,
      state: values.state,
      pincode: values.pincode,
      productDescription: values.productDescription,
      quantity: values.quantity,
      deliveryDate: values.deliveryDate,
      price: values.price,
    }
    addNonRegisterDealer(newProductInquiry)
      .then(responseFromApi => {
        if (responseFromApi.status && responseFromApi.code == 201) {
          validationProductInquiry.setSubmitting(false);
          validationProductInquiry.resetForm();
          setSelectedProductState(null)
          setToastInfo({
            message: responseFromApi.message,
            showToast: true,
            role: "success",
          });
        }
      })
      .catch((err) => { console.log(err); })
  }

  const handleToggle = tab => {
    setActiveTab(tab)
    validationProductInquiry.resetForm();
    validation.resetForm()
  }

  useEffect(() => {
    if (activeTab == 'productInquiry') {
      setShowDealerInquiry(false)
      setShowProductInquiry(true)
    } else {
      setShowDealerInquiry(true)
      setShowProductInquiry(false)
    }
  }, [activeTab])

  //date
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);
  const nextDate = currentDate.toISOString().split("T")[0];

  //state option
  useEffect(() => {
    getStateListForInquiry()
      .then((response) => {
        if (response.code == "200") {
          setStateList(response.data);
        }
      })
      .catch((error) => { });
  }, [])


  const handleInputChange = (value) => {
    validation.setFieldValue("state", value);
  };

  const handleInputChange2 = (value) => {
    validationProductInquiry.setFieldValue("state", value);
  };

  const [tooltipText, setTooltipText] = useState('');

  const handleMouseEnter = (type) => {
    if (type === 'dealer') {
      setTooltipText(
        <>
          <BsInfoCircle className="me-1" />
          If you want to connect with us as a Dealer, create
          New Dealer Inquiry.
        </>
      );
    } else if (type === 'product') {
      setTooltipText(
        <>
          <BsInfoCircle className="me-1" />
          If you have any Product related Inquiry, create
        New Product Inquiry.
        </>
      );
    }
  }
    const handleMouseLeave = () => {
      setTooltipText('');
    };
  
  return (
    <React.Fragment>
      <div className="account-pages bg-auth  account-pages-bg register-page" >

        <Row className="justify-content-center w-100 main-height">

          <Col
          sm={12}
            md={6}
            className="d-flex justify-content-center"
            style={{ overflow: "hidden", overflowX: 'hidden', overflowY: 'hidden'}}
          >
            <div className="form-layout-section ms-4 ms-md-0 h-100 login-section">
            <div className="d-flex justify-content-center">
                <img
                  src={"/subros_logo.png"}
                  alt=""
                  className="img-fluid ci-logo"
                />
              </div>

              <div
                className="d-flex"
                style={{ justifyContent: "center", flexDirection: 'column', }}
              >
                {/* <div>
                  <p
                    style={{ textAlign: "center", marginTop: '0px' }}
                    className="toggle-helper-text mb-2"
                  >
                    If you want to connect with us as a Dealer, create
                    <strong style={{ color: "#344fa0", margin: "0 5px" }}>
                     New Dealer Inqury.
                    </strong><br />
                    If you have any Product related Inquiry, create new
                    <strong style={{ color: "#344fa0", margin: "0 5px" }}>
                      New Product Inquiry.
                    </strong>
                  </p>
                </div> */}

                <div className="toggle-switch-container">
                  <div className="toggle-switch mb-0">
                    <label
                      className={`switch-label ${activeTab === "dealerInquiry" ? "active" : ""
                        }`}
                      onClick={() => handleToggle("dealerInquiry")}
                      onKeyDown={event => {
                        if (event.key === "Enter") {
                          handleToggle("dealerInquiry")
                        }
                      }}
                      data-tooltip-id={`my-tooltip-dealer`}
                      onMouseEnter={() => handleMouseEnter('dealer')}
                      onMouseLeave={handleMouseLeave}
                    >
                      Dealer Inquiry
                    </label>
                    <label
                      className={`switch-label ${activeTab === "productInquiry" ? "active" : ""
                        }`}
                      onClick={() => handleToggle("productInquiry")}
                      onKeyDown={event => {
                        if (event.key === "Enter") {
                          handleToggle("productInquiry")
                        }
                      }}
                      data-tooltip-id={`my-tooltip-product`}
                      onMouseEnter={() => handleMouseEnter('product')}
                      onMouseLeave={handleMouseLeave}
                    >
                     Product Inquiry
                    </label>
                    <div
                      className={`slider ${activeTab === "productInquiry" ? "slide-right" : ""
                        }`}
                    ></div>
                  </div>
                </div>
              </div>

              {/* Dealer Inquiry  */}
              {showDealerInquiry && <div
                style={{ textAlign: "center" }}
                className="d-flex  flex-column align-items-center"
              >
                <p
                    style={{ textAlign: "center", marginTop: '0px' }}
                    className="toggle-helper-text mb-2  mt-2"
                  >
                    Connect with us as a Dealer,
                    <strong style={{ color: "#000000", margin: "0 5px" }}>
                     Submit below details
                    </strong>
                </p>
              </div>}
              {showDealerInquiry && <div className="p-2 register-form">
                <Form
                  className="needs-validation"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="name"
                        placeholder="Enter Full Name"
                        type="text"
                        className="form-control"
                        id="validationUsername"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={
                          !!(validation.touched.name && validation.errors.name)
                        }
                        disabled={validation.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationUsername">Full Name *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="email"
                        placeholder="Enter Valid Email"
                        type="email"
                        className="form-control"
                        id="validationEmail"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          !!(validation.touched.email && validation.errors.email)
                        }
                        disabled={validation.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationEmail">Email *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="phone"
                        placeholder="Enter Contact Number"
                        type="text"
                        id="validationPhone"
                        className="form-control no-spin"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.phone || ""}
                        invalid={
                          !!(validation.touched.phone && validation.errors.phone)
                        }
                        disabled={validation.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validation.touched.phone && validation.errors.phone ? (
                        <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationPhone">Phone Number *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="companyName"
                        placeholder="Enter Company Name"
                        type="text"
                        className="form-control"
                        id="validationUsername"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        style={{ borderRadius: '1rem' }}
                        value={validation.values.companyName || ""}
                        invalid={
                          !!(validation.touched.companyName && validation.errors.companyName)
                        }
                        disabled={validation.isSubmitting}
                      />
                      {validation.touched.companyName && validation.errors.companyName ? (
                        <FormFeedback type="invalid">{validation.errors.companyName}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationPhone">Company Name *</Label>
                    </div>
                    </Col>
                  
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="address"
                        placeholder="Enter Full Name"
                        type="textarea"
                        className="form-control"
                        id="validationUsername"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.address || ""}
                        invalid={
                          !!(validation.touched.address && validation.errors.address)
                        }
                        disabled={validation.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validation.touched.address && validation.errors.address ? (
                        <FormFeedback type="invalid">{validation.errors.address}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationUsername">Address *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Select
                        type="select"
                        placeholder='State *'
                        options={stateList.map((option) => ({
                          label: option.name,
                          value: option.name,
                        }))}

                        className={`select-dropdown ${validation.touched.state && validation.errors.state
                          ? "is-invalid"
                          : ""
                          } select2-selection registerSelect`}
                        name="state"
                        id="state"
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 1000, // Adjust the z-index accordingly
                            marginLeft: '1px'
                          }),
                          input: (provided) => ({
                            ...provided,
                            height: '45px',
                          })
                        }}
                        onChange={(selectedOption) => {
                          setSelectedState(selectedOption);
                          handleInputChange(selectedOption.value);
                        }}
                        value={selectedState}
                      />
                      {validation.touched.state && validation.errors.state ? (
                        <FormFeedback type="invalid">
                          {validation.errors.state}
                        </FormFeedback>
                      ) : null}

                    </div>
                    </Col>
                    <Col sm={12}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="inquiry"
                        placeholder="Enter Inquiry"
                        type="textarea"
                        className="form-control"
                        id="validationUsername"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.inquiry || ""}
                        invalid={
                          !!(validation.touched.inquiry && validation.errors.inquiry)
                        }
                        disabled={validation.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validation.touched.inquiry && validation.errors.inquiry ? (
                        <FormFeedback type="invalid">{validation.errors.inquiry}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationUsername">Inquiry *</Label>
                    </div>
                    </Col>
                    
                  </Row>
                  <div className="w-100 mt-3 d-flex justify-content-center">
                    <Button
                      style={{ backgroundColor: '#344fa0', border: 'none' }}
                      type="submit">
                      <output>
                        {validation.isSubmitting && (
                          <span
                            className="spinner-border spinner-border-sm ms-2 me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </output>
                      {!validation.isSubmitting && <span>Submit</span>}
                      {validation.isSubmitting && <span>Submiting</span>}
                    </Button>
                  </div>
                </Form>
              </div>}

              {/* Product Inquiry  */}
              {showProductInquiry && <div
                style={{ textAlign: "center" }}
                className="d-flex  flex-column align-items-center"
              >
                 <p
                    style={{ textAlign: "center", marginTop: '0px' }}
                    className="toggle-helper-text mb-2 mt-2"
                  >
                    Any Product related Inquiry,
                    <strong style={{ color: "#000000", margin: "0 5px" }}>
                     Submit below details
                    </strong>
                </p>
              </div>}
              {showProductInquiry && <div className="p-2 ">

                <Form
                  className="needs-validation"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validationProductInquiry.handleSubmit();

                    return false;
                  }}
                >
                   <Row>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="fullName"
                        placeholder="Enter Full Name"
                        type="text"
                        className="form-control"
                        id="validationUsername"
                        onChange={validationProductInquiry.handleChange}
                        onBlur={validationProductInquiry.handleBlur}
                        value={validationProductInquiry.values.fullName || ""}
                        invalid={
                          !!(validationProductInquiry.touched.fullName && validationProductInquiry.errors.fullName)
                        }
                        disabled={validationProductInquiry.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validationProductInquiry.touched.fullName && validationProductInquiry.errors.fullName ? (
                        <FormFeedback type="invalid">{validationProductInquiry.errors.fullName}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationUsername">Full Name *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                        maxLength={inputMax}
                        name="email"
                        placeholder="Enter Valid Email"
                        type="text"
                        className="form-control"
                        id="validationAddress"
                        onChange={validationProductInquiry.handleChange}
                        onBlur={validationProductInquiry.handleBlur}
                        value={validationProductInquiry.values.email || ""}
                        invalid={
                          !!(validationProductInquiry.touched.email && validationProductInquiry.errors.email)
                        }
                        disabled={validationProductInquiry.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validationProductInquiry.touched.email && validationProductInquiry.errors.email ? (
                        <FormFeedback type="invalid">{validationProductInquiry.errors.email}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationAddress">Email *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="mobile"
                        placeholder="Enter Valid Mobile"
                        type="text"
                        className="form-control"
                        id="validationMobie"
                        onChange={validationProductInquiry.handleChange}
                        onBlur={validationProductInquiry.handleBlur}
                        value={validationProductInquiry.values.mobile || ""}
                        invalid={
                          !!(validationProductInquiry.touched.mobile && validationProductInquiry.errors.mobile)
                        }
                        disabled={validationProductInquiry.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validationProductInquiry.touched.mobile && validationProductInquiry.errors.mobile ? (
                        <FormFeedback type="invalid">{validationProductInquiry.errors.mobile}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationMobie">Phone Number *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                        maxLength={inputMax}
                        name="companyName"
                        placeholder="Enter Your Company Name"
                        type="textarea"
                        className="form-control"
                        id="validationCompanyName"
                        onChange={validationProductInquiry.handleChange}
                        onBlur={validationProductInquiry.handleBlur}
                        value={validationProductInquiry.values.companyName || ""}
                        invalid={
                          !!(validationProductInquiry.touched.companyName && validationProductInquiry.errors.companyName)
                        }
                        disabled={validationProductInquiry.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validationProductInquiry.touched.companyName && validationProductInquiry.errors.companyName ? (
                        <FormFeedback type="invalid">{validationProductInquiry.errors.companyName}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationCompanyName">Company Name *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="address"
                        placeholder="Enter Valid Address"
                        type="textarea"
                        className="form-control"
                        id="validationAddress"
                        onChange={validationProductInquiry.handleChange}
                        onBlur={validationProductInquiry.handleBlur}
                        value={validationProductInquiry.values.address || ""}
                        invalid={
                          !!(validationProductInquiry.touched.address && validationProductInquiry.errors.address)
                        }
                        disabled={validationProductInquiry.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validationProductInquiry.touched.address && validationProductInquiry.errors.address ? (
                        <FormFeedback type="invalid">{validationProductInquiry.errors.address}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationAddress">Address *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div>
                      <Col sm="12" md="12">

                        <Select

                          placeholder='State *'
                          options={stateList.map((option) => ({
                            label: option.name,
                            value: option.name,
                          }))}

                          className={`select-dropdown ${validationProductInquiry.touched.state && validationProductInquiry.errors.state
                            ? "is-invalid"
                            : ""
                            } form-floating registerSelect optionSelection `}
                          name="state"
                          id="state"
                          styles={{
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 1000, // Adjust the z-index accordingly
                              marginLeft: '1px'
                            }),
                            input: (provided) => ({
                              ...provided,
                              height: '45px',
                            }),

                          }}
                          onChange={(selectedOption) => {
                            handleInputChange2(selectedOption.value);
                            setSelectedProductState(selectedOption);
                          }}
                          value={selectedProductState}
                        />
                        {validationProductInquiry.touched.state && validationProductInquiry.errors.state ? (
                          <FormFeedback type="invalid">
                            {validationProductInquiry.errors.state}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="pincode"
                        placeholder="Enter your Pincode"
                        type="number"
                        className="form-control"
                        id="validationPincode"
                        onChange={validationProductInquiry.handleChange}
                        onBlur={validationProductInquiry.handleBlur}
                        style={{ borderRadius: '1rem' }}
                        value={validationProductInquiry.values.pincode || ""}
                        invalid={
                          !!(validationProductInquiry.touched.pincode && validationProductInquiry.errors.pincode)
                        }
                        disabled={validationProductInquiry.isSubmitting}
                      />
                      {validationProductInquiry.touched.pincode && validationProductInquiry.errors.pincode ? (
                        <FormFeedback type="invalid">{validationProductInquiry.errors.pincode}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationPincode">Pincode *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="productDescription"
                        placeholder="Enter Product Description"
                        type="textarea"
                        className="form-control"
                        id="validationDescription"
                        onChange={validationProductInquiry.handleChange}
                        onBlur={validationProductInquiry.handleBlur}
                        value={validationProductInquiry.values.productDescription || ""}
                        invalid={
                          !!(validationProductInquiry.touched.productDescription && validationProductInquiry.errors.productDescription)
                        }
                        disabled={validationProductInquiry.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validationProductInquiry.touched.productDescription && validationProductInquiry.errors.productDescription ? (
                        <FormFeedback type="invalid">{validationProductInquiry.errors.productDescription}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationDescription">Product Description *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="quantity"
                        placeholder="Enter quantity"
                        type="text"
                        className="form-control"
                        id="validationQuantity"
                        onChange={validationProductInquiry.handleChange}
                        onBlur={validationProductInquiry.handleBlur}
                        value={validationProductInquiry.values.quantity || ""}
                        invalid={
                          !!(validationProductInquiry.touched.quantity && validationProductInquiry.errors.quantity)
                        }
                        disabled={validationProductInquiry.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validationProductInquiry.touched.quantity && validationProductInquiry.errors.quantity ? (
                        <FormFeedback type="invalid">{validationProductInquiry.errors.quantity}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationQuantity">Quantity *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="deliveryDate"
                        placeholder="Enter Full Name"
                        type="date"
                        className="form-control"
                        id="validationDate"
                        onChange={validationProductInquiry.handleChange}
                        onBlur={validationProductInquiry.handleBlur}
                        value={validationProductInquiry.values.deliveryDate || ""}
                        invalid={
                          !!(validationProductInquiry.touched.deliveryDate && validationProductInquiry.errors.deliveryDate)
                        }
                        disabled={validationProductInquiry.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                        min={nextDate}
                      />
                      {validationProductInquiry.touched.deliveryDate && validationProductInquiry.errors.deliveryDate ? (
                        <FormFeedback type="invalid">{validationProductInquiry.errors.deliveryDate}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationDate">Expected Delivery Date *</Label>
                    </div>
                    </Col>
                    <Col sm={12} md={6}>
                    <div className="form-floating mb-3">
                      <Input
                       maxLength={inputMax}
                        name="price"
                        placeholder="Enter Price"
                        type="text"
                        className="form-control"
                        id="validationPrice"
                        onChange={validationProductInquiry.handleChange}
                        onBlur={validationProductInquiry.handleBlur}
                        value={validationProductInquiry.values.price || ""}
                        invalid={
                          !!(validationProductInquiry.touched.price && validationProductInquiry.errors.price)
                        }
                        disabled={validationProductInquiry.isSubmitting}
                        style={{ borderRadius: '1rem' }}
                      />
                      {validationProductInquiry.touched.price && validationProductInquiry.errors.price ? (
                        <FormFeedback type="invalid">{validationProductInquiry.errors.price}</FormFeedback>
                      ) : null}
                      <Label htmlFor="validationPrice">Expected Price *</Label>
                    </div>
                    </Col>
                  </Row>

                  <div className="w-100 mt-3 d-flex justify-content-center">
                    <Button
                      style={{ backgroundColor: '#344fa0', border: 'none' }}
                      type="submit">
                      <output>
                        {validationProductInquiry.isSubmitting && (
                          <span
                            className="spinner-border spinner-border-sm ms-2 me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </output>
                      {!validationProductInquiry.isSubmitting && <span>Submit</span>}
                      {validationProductInquiry.isSubmitting && <span>Submiting</span>}
                    </Button>
                  </div>
                </Form>
              </div>}

              <div className="mt-1 text-center">
                <p >
                  Already have an account ?{" "}
                  <Link to="/login"
                    style={{ color: "#344fa0" }}
                    className="fw-medium">
                    {" "}
                    Log in{" "}
                  </Link>{" "}
                </p>
                <p style={{ marginTop: "-10px" }}>© {new Date().getFullYear()} Powered by {" "}
                    <img
                      src={logo}
                      className="img-fluid"
                      style={{ width: "13px" }}

                    />
                    <Link
                      to="https://www.cashinvoice.in/"
                      target="_blank"
                      style={{ color: "#344fa0" }}
                      className="fw-medium"
                    >
                      {" "}
                      Cashinvoice
                    </Link>{" "}</p>
              </div>
            </div>
          </Col>
        </Row>

      </div>
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  )
}

export default withRouter(Register)

Register.propTypes = {
  history: PropTypes.object,
}
